var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan"},[_c('span',{staticClass:"mainText"},[_vm._v("网站浏览总数")]),_c('date'),_c('div',{staticClass:"numBox"},_vm._l((_vm.number),function(num,index){return _c('div',{key:index,staticClass:"number"},[_vm._v(_vm._s(num))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }